import { ValidationHelper } from "../../../ValidationHelper/ValidationHelper";
import { ViewModel } from "../../CoreTypes";
import { ModelEvent } from "../../EventManagement/ModelEvents/ModelEvent";
import { indent } from "../../../../../../Common/IndentString";

import { IValidationContext, IValueValidator, ValidationResult, ValidationResults } from "./Bases/IValueValidator";

export class CompositeValueValidatorWithForcedValidators implements IValueValidator {
    private readonly optional: boolean;
    private readonly forcedValidators: IValueValidator[];
    private readonly allValidators: IValueValidator[];

    public constructor(optional: boolean, validators: IValueValidator[], forcedValidators: IValueValidator[]) {
        this.optional = optional;
        this.forcedValidators = forcedValidators;
        this.allValidators = [...validators, ...forcedValidators];
    }

    public async validate(context: IValidationContext, nodeViewModel: ViewModel): Promise<ValidationResult> {
        const events: ModelEvent[] = [];
        if (this.optional && ValidationHelper.isBlank(nodeViewModel.value)) {
            for (const validator of this.forcedValidators) {
                const result = await validator.validate(context, nodeViewModel);
                events.push(...(result.additionalEvents ?? []));
                if (result.valid && result.forceValid) {
                    return ValidationResults.ValidWithEvents(events);
                }
                if (!result.valid) {
                    return { ...result, additionalEvents: events };
                }
            }
            return ValidationResults.ValidWithEvents(events);
        }
        for (const validator of this.allValidators) {
            const result = await validator.validate(context, nodeViewModel);
            events.push(...(result.additionalEvents ?? []));
            if (result.valid && result.forceValid) {
                return ValidationResults.ValidWithEvents(events);
            }
            if (!result.valid) {
                return { ...result, additionalEvents: events };
            }
        }
        return ValidationResults.ValidWithEvents(events);
    }

    public asDebugString(): string {
        return [
            `new CompositeValueValidatorWithForcedValidators {`,
            `  optional: ${this.optional},`,
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            `  forcedValidators: ${this.forcedValidators},`,
            `  allValidators: [`,
            `${indent(this.allValidators.map(x => x.asDebugString()).join(",\n"), 4)}`,
            `  ]`,
            `}`,
        ].join("\n");
    }
}
